module.exports = __webpack_public_path__ + "img/availableColors.d904af6.jpg";